import React, { useEffect, useState } from "react";
import "./Product_details_swiper.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Best_seller_heart from "../../common-components/product_card/Best_seller_heart/Best_seller_heart";
import { variant_type } from "../../../utils/common";

function Product_details_swiper({ product, selectedVariant }) {
  const [activeImage, setActiveImage] = useState("");

  useEffect(() => {
    if (
      product?.variant_type_id === variant_type.Single &&
      selectedVariant?.Product_Images?.length > 0
    ) {
      setActiveImage(selectedVariant.Product_Images[0].image);
    } else if (
      Number(product?.variant_type_id) === Number(variant_type.Double) &&
      selectedVariant?.Product_Variant?.Product_Images?.length > 0
    ) {
      console.log(
        selectedVariant.Product_Variant?.Product_Images[0].image,
        "selectedVariant.Product_Variant?.Product_Images[0].image",
      );

      setActiveImage(selectedVariant.Product_Variant?.Product_Images[0].image);
    } else if (
      Number(product?.variant_type_id) === variant_type.Triple &&
      selectedVariant?.Double_Variant?.Product_Variant?.Product_Images?.length >
        0
    ) {
      setActiveImage(
        selectedVariant.Double_Variant?.Product_Variant?.Product_Images[0]
          .image,
      );
    } else if (product?.image) {
      setActiveImage(product.image);
    }
  }, [selectedVariant, product]);

  return (
    <>
      <section className="Product_details_swiper">
        <div className="main_img_holder">
          <div className="img_holder">
            <img
              className="Product_img"
              src={process.env.REACT_APP_IMG_URL + activeImage}
              alt="Product_img"
            />
            {/* <img
              className="Product_img"
              // src={
              //     process.env.PUBLIC_URL +
              //     '/assets/images/product_details/ghee/Ghee-bottle.png'
              // }
              src={process.env.REACT_APP_IMG_URL + product.image}
              alt="Product_img"
            /> */}
          </div>
          {/* <div className="like_icon_holder" onClick={toggleLike}>
            <FontAwesomeIcon
              className={`like_icon ${liked ? "active" : ""} ${sparkle ? "sparkle" : ""
                }`}
              icon={liked ? solidHeart : regularHeart}
            />
          </div> */}

          <div className="wishlist_div">
            <Best_seller_heart product={product} />
          </div>
        </div>

        <div className="swiper_holder">
          <Swiper
            slidesPerView={5}
            spaceBetween={10}
            className="Product_details_Swiper_holder"
          >
            {Number(product?.variant_type_id) === variant_type.Single &&
              selectedVariant?.Product_Images?.map((val, index) => (
                <SwiperSlide
                  key={index}
                  onClick={() => setActiveImage(val.image)}
                >
                  <div
                    className={`img_holder ${
                      activeImage === val.image ? "active_thumb" : ""
                    }`}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      alt="Product Thumbnail"
                      className="Product_img"
                    />
                  </div>
                </SwiperSlide>
              ))}

            {Number(product?.variant_type_id) === variant_type.Double &&
              selectedVariant?.Product_Variant?.Product_Images?.map(
                (val, index) => (
                  <SwiperSlide
                    key={index}
                    onClick={() => setActiveImage(val.image)}
                  >
                    <div
                      className={`img_holder ${
                        activeImage === val.image ? "active_thumb" : ""
                      }`}
                    >
                      <img
                        src={process.env.REACT_APP_IMG_URL + val?.image}
                        alt="Product Thumbnail"
                        className="Product_img"
                      />
                    </div>
                  </SwiperSlide>
                ),
              )}

            {Number(product?.variant_type_id) === variant_type.Triple &&
              selectedVariant?.Double_Variant?.Product_Variant?.Product_Images?.map(
                (val, index) => (
                  <SwiperSlide
                    key={index}
                    onClick={() => setActiveImage(val.image)}
                  >
                    <div
                      className={`img_holder ${
                        activeImage === val.image ? "active_thumb" : ""
                      }`}
                    >
                      <img
                        src={process.env.REACT_APP_IMG_URL + val?.image}
                        alt="Product Thumbnail"
                      />
                    </div>
                  </SwiperSlide>
                ),
              )}
          </Swiper>
        </div>
      </section>
    </>
  );
}

export default Product_details_swiper;
